import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import KiloNewton from "../../../../../../components/Math/Units/Metric/KiloNewton";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function KnicklastDesGebettetenPfahls({ knicklastDesGebettetenPfahls = 0 }) {
  const { t } = useTranslation("translation");
  const N_ki_Formula = `\\displaystyle N_{ki} = \\overline{N}_{ki} + \\frac{c \\cdot {L_{\\small{Hw}}}^2}{\\pi^2}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.bucklingLoadEmbeddedPile")}</p>}
      indicesValue={
        <span>
          N<sub>ki</sub>
        </span>
      }
      formulaValue={<ToolTip id={"N_ki_Formula"} type={IconType.FORMULA} formula={N_ki_Formula} />}
      inputValue={<span className="input">{ConvertToString(knicklastDesGebettetenPfahls, 0)}</span>}
      unitValue={<KiloNewton />}
    />
  );
}

export default KnicklastDesGebettetenPfahls;
